module.exports = "<p>\r\n  portfoliotarget works!\r\n</p>\r\n"